import { Navigate, Outlet } from "react-router-dom";
import { roleCheck } from "../lib/roleCheck";
import { getDefaultPagePerRoleBo } from "../lib/roleBasedDefaultPage";

type ProtectedSubRouteBoProps = {
  allowedRoles: string[];
  role: string;
};

export const ProtectedSubRouteBo = ({ role, allowedRoles }: ProtectedSubRouteBoProps) => {
  if (!roleCheck(allowedRoles, role)) {
    return <Navigate to={getDefaultPagePerRoleBo(role)} />;
  }
  return <Outlet />;
};
